import { render } from "./EmailEditor.vue?vue&type=template&id=eb864766&scoped=true"
import script from "./EmailEditor.vue?vue&type=script&lang=js"
export * from "./EmailEditor.vue?vue&type=script&lang=js"

import "./EmailEditor.vue?vue&type=style&index=0&id=eb864766&scoped=true&lang=css"

import exportComponent from "/Users/adeelraza/Projects/unlayer/vue-email-editor/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb864766"]])

export default __exports__